
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import EuButton from '../Button/Button.vue';
import CloseIcon from '../../../Icons/CloseIcon.vue';
/**
- use prop <b>closable</b> to show the actioncard with close button.
- to show button on closable actioncard, just pass <b>buttonLabel</b> prop.
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralActionCard',
  components: {
    EuCard,
    EuButton,
    CloseIcon
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set image
     */
    image: {
      type: String,
      default: ''
    },
    /**
     * Set closable action card
     */
    closable: {
      type: Boolean,
      default: false
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set subtitle
     */
    subtitle: {
      type: String,
      default: ''
    },
    /**
     * Set Button Label
     */
    buttonLabel: {
      type: String,
      default: ''
    },
    /**
     * Set Button on disabled
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Set trigger when button is clicked, it shows a new action section on the right side of the card
     */
    activateCustomSection: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedBackground() {
      return `background-image: url(${this.image})`;
    },
    showingCustomAction() {
      return this.$slots.customAction && this.activateCustomSection;
    }
  },
  methods: {
    handleCardClick(e: any) {
      /**
       * Method to click card
       * @event click-card
       * @type {function}
       */
      this.$emit('click-card', e);
    },
    handleClick(e: any) {
      /**
       * Method to click button
       * @event click
       * @type {function}
       */
      this.$emit('click', e);
    },
    handleClose(e: any) {
      /**
       * Method to click close icon on closable GeneralActionCard
       * @event close
       * @type {function}
       */
      this.$emit('close', e);
    }
  }
});
